// Articles-view behaviour; independent of the map script, and every part is
// guarded on its elements existing, so it is a no-op elsewhere.
(function () {
  // ARTICLE SOCIAL EMBEDS (Instagram / Facebook) - official embeds keep
  // attribution and sidestep Instagram's expiring CDN URLs. Each SDK loads
  // only when the article contains an embed.
  (function () {
    /* A LINK IN THE ARTICLE, AN EMBED ON THE PAGE
       Articles store a plain link on its own line; the embed markup is built
       here at render time. The admin editor drops markup no plugin claims, so
       a stored embed blockquote would vanish on the next save - and a link
       degrades to a working link when JS, the SDK or the post is gone.

       WHAT QUALIFIES: a paragraph whose ONLY content is one link to a post or
       reel (or an image, below). Mid-sentence links, and links to profiles,
       groups or pages, stay links. */
    const INSTAGRAM = /^https?:\/\/(?:www\.)?instagram\.com\/(?:[A-Za-z0-9_.]+\/)?(?:p|reel|tv)\/[A-Za-z0-9_-]+/i;
    const FACEBOOK = /^https?:\/\/(?:www\.|web\.|m\.)?facebook\.com\/(?:[^\/]+\/(?:posts|videos|photos)\/|share\/[pv]\/|permalink\.php|photo\.php|watch\/?\?v=)/i;

    // An image link, by extension - checked against the path only, so a
    // resizing query string (?w=1600&fm=jpg) does not hide the .jpg.
    const IMAGE_PATH = /\.(?:jpe?g|png|webp|gif|avif)$/i;

    // ...or by host, for image-only CDNs whose URLs have no extension.
    // lh3.googleusercontent.com is where the map's own place photos live.
    const IMAGE_HOSTS = /^https?:\/\/(?:images\.unsplash\.com|images\.pexels\.com|cdn\.pixabay\.com|lh3\.googleusercontent\.com|static\.where-e\.com)\//i;

    function looksLikeImage(href) {
      if (IMAGE_HOSTS.test(href)) return true;

      const path = href.split('#')[0].split('?')[0];

      return IMAGE_PATH.test(path);
    }

    function autoEmbed() {
      const body = dom.one('.article-body');
      if (!body) return;

      // dom.all returns a static array, so replacing paragraphs mid-loop is
      // safe.
      dom.all('p > a[href]', body).forEach(link => {
        const p = link.parentNode;

        // The link and nothing else: one child, no stray text around it.
        if (p.children.length !== 1) return;
        if (p.textContent.trim() !== link.textContent.trim()) return;

        const href = link.getAttribute('href');
        if (!href) return;

        // morph(), not a swap: the embed is a different tag from the <p>, and
        // morphdom then makes a new element in the <p>'s place and reconciles
        // the embed's attributes and fallback link into it.
        if (INSTAGRAM.test(href)) {
          dom.morph(p, instagramEmbed(href));
        } else if (FACEBOOK.test(href)) {
          dom.morph(p, facebookEmbed(href));
        } else if (looksLikeImage(href)) {
          dom.morph(p, imageEmbed(href, link.textContent.trim()));
        }
      });
    }

    /* Instagram's embed endpoint only answers to the SHORT permalink; the
       app copies the long one, whose /embed/ 404s:

           https://www.instagram.com/zareeneats/reel/C5HLJ8sPGxq/   <- copied
           https://www.instagram.com/reel/C5HLJ8sPGxq/              <- embeddable

       So the account name is dropped. */
    function canonicalInstagram(href) {
      return href.replace(
        /^(https?:\/\/(?:www\.)?instagram\.com\/)[A-Za-z0-9_.]+\/((?:p|reel|tv)\/)/i,
        '$1$2'
      );
    }

    function instagramEmbed(href) {
      // Instagram's own snippet, rebuilt: permalink attribute, version 14,
      // and the link kept inside as the fallback the SDK replaces.
      const quote = document.createElement('blockquote');
      quote.className = 'instagram-media';
      quote.setAttribute('data-instgrm-captioned', '');
      quote.setAttribute('data-instgrm-permalink', withParam(canonicalInstagram(href), 'utm_source=ig_embed'));
      quote.setAttribute('data-instgrm-version', '14');
      quote.setAttribute('style', 'background:#FFF;border:0;border-radius:12px;margin:26px auto;'
        + 'max-width:540px;min-width:326px;padding:0;width:calc(100% - 2px)');

      quote.appendChild(fallbackLink(href, 'View this post on Instagram'));

      return quote;
    }

    function facebookEmbed(href) {
      const div = document.createElement('div');
      div.className = 'fb-post';
      div.setAttribute('data-href', href);
      div.setAttribute('data-width', '500');

      div.appendChild(fallbackLink(href, 'View this post on Facebook'));

      return div;
    }

    /* What the SDKs replace, and what the reader keeps if they never load. */
    function fallbackLink(href, text) {
      const a = document.createElement('a');

      a.href = href;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = text;

      return a;
    }

    /* An image link becomes a figure served through our image proxy (some
       hosts refuse hotlinks; the proxy caches). The link text is the caption,
       unless it is just the URL. */
    function imageEmbed(href, label) {
      const captioned = label && label !== href && !/^https?:\/\//i.test(label);

      const figure = document.createElement('figure');
      figure.className = 'article-figure';

      const img = document.createElement('img');
      img.className = 'article-figure-img';
      // data-src, not src: window.hcLazy (main.js) loads and fades these in;
      // the stylesheet starts them at opacity 0. mark=1 stamps the wordmark so
      // a reposted image says where it came from; mv is the mark version, a
      // cache-buster for immutable copies.
      img.setAttribute('data-src', withParam(proxied(href), 'mark=1&mv=' + (window.__hcMarkVersion || 1)));
      img.setAttribute('data-fallback', 'none');
      // The caption doubles as alt; no caption means an empty alt.
      img.setAttribute('alt', captioned ? label : '');

      figure.appendChild(img);

      if (captioned) {
        const caption = document.createElement('figcaption');
        caption.textContent = label;
        figure.appendChild(caption);
      }

      return figure;
    }

    /* Every in-article figure, measured on load: near-16:9 images keep the
       standard crop, other shapes (screenshots, phone captures) keep their
       own. Covers the figures built above AND the ones the server renders
       from a paragraph holding one <img> (App\Support\ArticleBody), which
       mirror imageEmbed()'s markup. */
    function measureFigures(container) {
      if (!container) return;

      dom.all('.article-figure-img', container).forEach(img => {
        if (img.dataset.hcMeasured) return;
        img.dataset.hcMeasured = '1';

        // hcLazy may already have loaded it if the load order changes.
        if (img.complete && img.naturalWidth) {
          measure(img);
        } else {
          img.addEventListener('load', () => measure(img), { once: true });
        }
      });
    }

    function measure(img) {
      const w = img.naturalWidth;
      const h = img.naturalHeight;

      if (!w || !h) return;

      // 12% either side of 16:9: covers 1400x788 and 1200x630, not 4:3.
      // Also in ArticleBody::RATIO_TOLERANCE.
      if (Math.abs(w / h - 16 / 9) > (16 / 9) * 0.12) {
        img.classList.add('is-natural');
      }
    }

    /* Decode before encoding so an already-encoded URL is not double-encoded.
       Duplicated server-side in ArticleBody::markedSrc().
       Duplicates proxiedImageSrc() in main.js, which loads after this file. */
    function proxied(url) {
      let normalized = url;

      try {
        normalized = decodeURIComponent(url);
      } catch (err) {
        // Malformed - send it unchanged.
      }

      return `/api/image.php?url=${encodeURIComponent(normalized)}`;
    }

    function withParam(url, param) {
      return `${url}${url.includes('?') ? '&' : '?'}${param}`;
    }

    // Before the SDK checks below, which look for the markup this just built.
    autoEmbed();
    measureFigures(dom.one('.article-body'));

    // hcLazy is defined later and scans on DOMContentLoaded anyway; this only
    // matters if the load order changes.
    if (window.hcLazy && window.hcLazy.scan) {
      window.hcLazy.scan(dom.one('.article-body'));
    }

    // crossOrigin ONLY for Facebook's SDK, which requires it. Instagram's
    // embed.js has no CORS headers, so in CORS mode it is silently discarded.
    function addScript(src, useCors, onload) {
      const el = document.createElement('script');

      el.async = true;
      el.defer = true;
      el.src = src;
      if (useCors) el.crossOrigin = 'anonymous';
      if (onload) { el.onload = onload; el.onerror = onload; }
      dom.insert(document.body, el);
    }

    const needsInstagram = !!dom.one('.article-body blockquote.instagram-media');
    const needsFacebook = !!dom.one('.article-body .fb-page, .article-body .fb-post');

    function loadFacebook() {
      if (!needsFacebook) return;

      // The SDK needs #fb-root first. Not dom.id(): a cached miss would go
      // stale once it is created.
      if (!document.getElementById('fb-root')) {
        const root = document.createElement('div');

        root.id = 'fb-root';
        dom.insert(document.body, root, document.body.firstChild);
      }

      addScript('https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v19.0', true);
    }

    // In sequence, Instagram first: loaded together, Facebook's SDK can win a
    // race that leaves Instagram's embed.js uninitialised.
    if (needsInstagram) {
      addScript('https://www.instagram.com/embed.js', false, () => {
        if (window.instgrm && window.instgrm.Embeds) {
          try { window.instgrm.Embeds.process(); } catch (e) { /* SDK not ready */ }
        }

        setTimeout(loadFacebook, 300);
      });
    } else {
      loadFacebook();
    }
  })();

  // ARTICLE TABLES - stored as plain HTML (a <thead> row of column names,
  // td.verdict-yes / -no / -check for verdicts); dressed here at render time
  // so the stored markup stays plain and every article gets the same design.
  // See "REFERENCE TABLES IN ARTICLES" in articles.css.
  //   - each body cell gets data-label = its column's header, which the
  //     phone layout (one card per row) prints above the value;
  //   - a verdict cell's words go into a .verdict-pill (the words stay text);
  //     a sentence-long verdict is marked .verdict-long so it wraps;
  //   - a column headed "Source..." that holds no verdicts is .col-source;
  //   - ARIA table roles, because the phone layout's display:block/grid
  //     strips a table's native semantics in some browsers.
  (function () {
    const VERDICTS = ['verdict-yes', 'verdict-no', 'verdict-check'];
    const LONG_VERDICT = 28;
    const SOURCE_HEADER = /^sources?\b/i;

    const isVerdict = (cell) => VERDICTS.some((name) => cell.classList.contains(name));

    function dress(table) {
      const head = table.tHead && table.tHead.rows[0];
      const labels = [];

      if (head) {
        let col = 0;
        for (const th of head.cells) {
          for (let span = th.colSpan || 1; span > 0; span--) labels[col++] = th.textContent.trim();
        }
      }

      // Each body row as [cell, column index] pairs, colspans counted.
      const rows = [];
      for (const body of table.tBodies) {
        body.setAttribute('role', 'rowgroup');
        for (const row of body.rows) {
          const cells = [];
          let col = 0;
          for (const cell of row.cells) {
            cells.push([cell, col]);
            col += cell.colSpan || 1;
          }
          rows.push([row, cells]);
        }
      }

      const verdictCols = new Set();
      rows.forEach(([, cells]) => cells.forEach(([cell, col]) => { if (isVerdict(cell)) verdictCols.add(col); }));
      const sourceCols = new Set();
      labels.forEach((label, col) => { if (SOURCE_HEADER.test(label) && !verdictCols.has(col)) sourceCols.add(col); });

      table.setAttribute('role', 'table');
      if (table.tHead) {
        table.tHead.setAttribute('role', 'rowgroup');
        for (const row of table.tHead.rows) {
          row.setAttribute('role', 'row');
          let col = 0;
          for (const th of row.cells) {
            th.setAttribute('role', 'columnheader');
            if (sourceCols.has(col)) th.classList.add('col-source');
            col += th.colSpan || 1;
          }
        }
      }

      rows.forEach(([row, cells]) => {
        row.setAttribute('role', 'row');
        cells.forEach(([cell, col]) => {
          cell.setAttribute('role', cell.tagName === 'TH' ? 'rowheader' : 'cell');
          if (labels[col] && !cell.hasAttribute('data-label')) cell.setAttribute('data-label', labels[col]);
          if (sourceCols.has(col)) cell.classList.add('col-source');

          if (isVerdict(cell) && !cell.querySelector('.verdict-pill')) wrapVerdict(cell);
        });
      });
    }

    /* The cell's words go into a .verdict-pill. The pill is built around
       copies of them and patched in, so the live cell is reconciled rather
       than having its children moved by hand. */
    function wrapVerdict(cell) {
      const wrapped = cell.cloneNode(false);
      const pill = document.createElement('span');

      pill.className = 'verdict-pill';
      Array.from(cell.childNodes).forEach(node => pill.appendChild(node.cloneNode(true)));
      wrapped.appendChild(pill);
      dom.patch(cell, wrapped);

      if (pill.textContent.trim().length > LONG_VERDICT) cell.classList.add('verdict-long');
    }

    dom.all('.article-body table').forEach(dress);
  })();

  // DATED TABLE ROWS - a table with data-current-label ("This month") whose
  // rows carry data-date (YYYY-MM-DD, in date order) marks the row in force
  // today: .is-current, aria-current, and the label on its first cell
  // (data-now, printed by the stylesheet). Nothing is marked before the first
  // row, or after the table's data-until. Today is the reader's own day.
  (function () {
    const DAY = /^\d{4}-\d{2}-\d{2}$/;

    function localDay(date) {
      const pad = (n) => String(n).padStart(2, '0');

      return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
    }

    // ISO days compare as strings.
    function currentRowIndex(dates, today, until) {
      if (until && DAY.test(until) && today > until) return -1;

      let current = -1;
      dates.forEach((date, i) => { if (DAY.test(date) && date <= today) current = i; });

      return current;
    }

    dom.all('.article-body table[data-current-label]').forEach((table) => {
      const rows = Array.from(table.querySelectorAll('tbody tr[data-date]'));
      const i = currentRowIndex(rows.map((row) => row.getAttribute('data-date')), localDay(new Date()), table.getAttribute('data-until') || '');

      if (i < 0) return;

      rows[i].classList.add('is-current');
      rows[i].setAttribute('aria-current', 'date');
      if (rows[i].cells[0]) rows[i].cells[0].setAttribute('data-now', table.getAttribute('data-current-label'));
    });
  })();

  // ARTICLES HERO VIDEO - the muted, looping YouTube background, injected at
  // runtime so reduced-motion, crawlers and no-JS visitors get the hero's
  // gradient instead. loop=1 needs playlist=<same id> (YouTube's API).
  (function () {
    const hero = dom.id('articles-hero');
    if (!hero) return;

    const mount = dom.id('articles-hero-video');
    const videoId = hero.getAttribute('data-video-id');
    if (!mount || !videoId) return;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    const params = [
      'autoplay=1',
      'mute=1',            // required - browsers block unmuted autoplay
      'loop=1',
      'playlist=' + videoId,
      'controls=0',
      'disablekb=1',
      'fs=0',
      'modestbranding=1',
      'rel=0',
      'iv_load_policy=3',
      'playsinline=1',
      // Player state over postMessage - see revealHeroVideo(). origin is
      // required alongside enablejsapi.
      'enablejsapi=1',
      'origin=' + encodeURIComponent(window.location.origin),
    ].join('&');

    // An exact 16:9 cover box, so YouTube never letterboxes.
    function sizeHeroVideo() {
      const w = hero.offsetWidth;
      const h = hero.offsetHeight;
      if (!w || !h) return;

      const scale = Math.max(w / 16, h / 9);

      mount.style.width = `${Math.ceil(scale * 16)}px`;
      mount.style.height = `${Math.ceil(scale * 9)}px`;
    }
    sizeHeroVideo();

    let resizeQueued = false;

    window.addEventListener('resize', () => {
      if (resizeQueued) return;
      resizeQueued = true;
      requestAnimationFrame(() => {
        resizeQueued = false;
        sizeHeroVideo();
      });
    });

    const iframe = document.createElement('iframe');

    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?${params}`;
    iframe.title = 'Background video';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('tabindex', '-1');
    iframe.setAttribute('aria-hidden', 'true');

    // Hidden until the player reports PLAYING. Phones often refuse autoplay
    // (Low Power Mode, low battery, a stripped Referer -> error 153), and a
    // controls-less player would then be a black box over the gradient.
    let revealed = false;

    function revealHeroVideo() {
      if (revealed) return;
      revealed = true;
      mount.classList.add('is-playing');
    }

    const PLAYING = 1;

    window.addEventListener('message', (event) => {
      if (event.source !== iframe.contentWindow) return;

      let data = event.data;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (e) { return; }
      }
      if (!data || typeof data !== 'object') return;

      // Two shapes carry the state: the onStateChange event, and the
      // periodic infoDelivery whose payload includes playerState.
      if (data.event === 'onStateChange' && data.info === PLAYING) {
        revealHeroVideo();
      } else if (data.event === 'infoDelivery' && data.info && data.info.playerState === PLAYING) {
        revealHeroVideo();
      }
    });

    // The player only starts posting state once told there is a listener.
    iframe.addEventListener('load', () => {
      if (!iframe.contentWindow) return;
      iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: 'articles-hero-video' }), '*');
    });

    dom.insert(mount, iframe);
  })();

  /* THE DEVICE'S OWN SHARE SHEET, and the clipboard when there is none.
     Always rendered, like sharePlace() in app.js: without navigator.share
     the link goes to the clipboard, confirmed by the copy button's "Copied"
     label. */
  const btn = dom.id('article-copy-link');
  if (!btn) return;

  // Only the <span> label's text is swapped, so the icon beside it stays.
  const label = dom.one('span', btn);

  // Read once at wire-up, so a second click mid-"Copied" cannot record
  // "Copied" as the text to restore.
  const originalLabel = label ? label.textContent : '';

  let resetTimer = null;

  /** Copies a URL and says so on the Copy link button. */
  function copyLink(url) {
    const done = () => {
      if (!label) return;

      dom.text(label, 'Copied');
      btn.classList.add('copied');
      clearTimeout(resetTimer);
      resetTimer = setTimeout(() => {
        dom.text(label, originalLabel);
        btn.classList.remove('copied');
      }, 1600);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, done);

      return;
    }

    const tmp = document.createElement('input');

    tmp.value = url;
    dom.insert(document.body, tmp);
    tmp.select();
    try { document.execCommand('copy'); } catch (e) { /* nothing else to try */ }
    dom.remove(tmp);
    done();
  }

  btn.addEventListener('click', () => {
    copyLink(btn.getAttribute('data-url') || window.location.href);
  });

  const nativeShare = dom.id('article-native-share');

  if (nativeShare) {
    nativeShare.addEventListener('click', () => {
      const url = nativeShare.getAttribute('data-url') || window.location.href;
      const title = nativeShare.getAttribute('data-title') || document.title;

      /* No canShare() pre-check - it misreports shareable payloads in some
         browsers (as in sharePlace() in app.js). The headline also goes in
         `text`, since Chrome on macOS drops `title` for many targets. */
      if (navigator.share) {
        navigator.share({ title: title, text: title, url: url }).catch((err) => {
          // AbortError is the visitor cancelling - do not copy anyway.
          if (err && err.name === 'AbortError') return;

          copyLink(url);
        });

        return;
      }

      copyLink(url);
    });
  }
})();

// ---- Article search - the topbar box on articles pages ----
// Same ids and dropdown classes as the map's place search, so it shares its
// styles and keyboard pattern; stands down on the map route. The index
// (/api/articles, titles and excerpts) is fetched on first focus.
(function () {
  if (!document.body.classList.contains('articles-mode')) return;

  const input = dom.id('search');
  const dropdown = dom.id('search-suggestions');
  const topbar = dom.id('topbar');

  if (!input || !dropdown) return;

  const PAGE = 6;
  const MORE = 12;
  let limit = PAGE;
  let lastQuery = '';
  let highlighted = -1;

  // null until the first focus; a promise while in flight; an array after.
  let index = null;

  function token() {
    const meta = document.querySelector('meta[name="hc-token"]');

    return meta ? meta.content : '';
  }

  function loadIndex() {
    if (index) return index;

    index = fetch('/api/articles', {
      cache: 'no-store',
      headers: token() ? { 'X-HC-Token': token() } : {},
    })
      .then(res => (res.ok ? res.json() : Promise.reject(new Error('http ' + res.status))))
      .then(list => { index = Array.isArray(list) ? list : []; return index; })
      // Not cached on failure - the next focus retries.
      .catch(() => { index = null; return []; });

    return index;
  }

  function el(tag, className, text) {
    const node = document.createElement(tag);

    if (className) node.className = className;
    if (text) node.textContent = text;

    return node;
  }

  /** A text run with the matched part in <mark>, as in the map search. */
  function highlightNodes(text, query) {
    const fragment = document.createDocumentFragment();
    const idx = query ? text.toLowerCase().indexOf(query.toLowerCase()) : -1;

    if (idx === -1) {
      fragment.appendChild(document.createTextNode(text));

      return fragment;
    }

    fragment.appendChild(document.createTextNode(text.slice(0, idx)));
    fragment.appendChild(el('mark', 'search-match', text.slice(idx, idx + query.length)));
    fragment.appendChild(document.createTextNode(text.slice(idx + query.length)));

    return fragment;
  }

  function setOpen(open) {
    dropdown.classList.toggle('visible', open);

    if (topbar) topbar.classList.toggle('search-open', open);
  }

  function close() {
    setOpen(false);
    dom.patch(dropdown, '');
    highlighted = -1;
  }

  // Title prefix, then title, then excerpt. rank() in mcp-tools.js matches.
  function score(article, q) {
    const title = article.title.toLowerCase();
    const excerpt = (article.excerpt || '').toLowerCase();

    if (title.startsWith(q)) return 0;
    if (title.includes(q)) return 1;
    if (excerpt.includes(q)) return 2;

    return -1;
  }

  function select(article) {
    input.value = '';
    close();
    input.blur();
    window.location.href = '/articles/' + encodeURIComponent(article.slug) + '/';
  }

  function render(list) {
    const query = input.value.trim();

    highlighted = -1;

    if (query !== lastQuery) {
      lastQuery = query;
      limit = PAGE;
    }

    if (!query) {
      close();

      return;
    }

    const q = query.toLowerCase();
    const scored = [];

    list.forEach(a => {
      const rank = score(a, q);

      if (rank !== -1) scored.push({ article: a, rank });
    });

    // Rank, then newest first, like the articles index.
    scored.sort((a, b) => (a.rank - b.rank)
      || String(b.article.publishedAt).localeCompare(String(a.article.publishedAt)));

    const total = scored.length;
    const matches = scored.slice(0, limit).map(s => s.article);

    if (matches.length === 0) {
      const none = document.createElement('div');

      none.appendChild(el('div', 'suggestion-empty', 'No matching articles'));
      dom.patch(dropdown, none);
      setOpen(true);

      return;
    }

    // Patched in, keyed on slug, so rows that still match keep their place
    // and loaded thumbnails.
    const built = document.createElement('div');

    matches.forEach(a => {
      const item = document.createElement('div');

      item.id = 'suggestion-article-' + a.slug;
      item.className = 'suggestion-item';
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-label', 'Read ' + a.title);
      item.title = a.title;

      const text = el('div', 'suggestion-text');
      const titleMatched = a.title.toLowerCase().includes(q);

      const nameEl = el('div', 'suggestion-name');

      nameEl.appendChild(titleMatched ? highlightNodes(a.title, query) : document.createTextNode(a.title));
      text.appendChild(nameEl);

      if (a.excerpt) {
        const detailsEl = el('div', 'suggestion-details');

        detailsEl.appendChild(titleMatched ? document.createTextNode(a.excerpt) : highlightNodes(a.excerpt, query));
        text.appendChild(detailsEl);
      }

      if (a.image) {
        const img = el('img', 'suggestion-thumb');

        // Loaded by window.hcLazy.
        img.setAttribute('data-src', a.image);
        img.setAttribute('data-fallback', 'none');
        img.setAttribute('alt', '');
        item.appendChild(img);
      }

      item.appendChild(text);

      // mousedown, not click: it fires before the input's blur closes the
      // dropdown.
      item.addEventListener('mousedown', e => {
        e.preventDefault();
        select(a);
      });
      item.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          select(a);
        }
      });
      built.appendChild(item);
    });

    if (total > matches.length) {
      const remaining = total - matches.length;
      const more = document.createElement('div');

      more.id = 'suggestion-more';
      more.className = 'suggestion-more';
      more.setAttribute('role', 'button');
      more.setAttribute('tabindex', '0');
      more.textContent = 'Show ' + Math.min(MORE, remaining) + ' more (' + remaining + ' left)';
      more.addEventListener('mousedown', e => {
        e.preventDefault();
        limit += MORE;
        render(list);
      });
      more.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          limit += MORE;
          render(list);
        }
      });
      built.appendChild(more);
    }

    dom.patch(dropdown, built);
    setOpen(true);

    if (window.hcLazy) window.hcLazy.scan(dropdown);
  }

  function rerender() {
    Promise.resolve(loadIndex()).then(list => render(Array.isArray(list) ? list : (index || [])));
  }

  input.addEventListener('focus', () => { loadIndex(); });
  input.addEventListener('input', rerender);

  input.addEventListener('keydown', (e) => {
    const items = dom.all('.suggestion-item', dropdown);

    if (!items.length) return;

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();

      if (e.key === 'ArrowDown') {
        highlighted = highlighted < items.length - 1 ? highlighted + 1 : 0;
      } else {
        highlighted = highlighted > 0 ? highlighted - 1 : items.length - 1;
      }
      items.forEach((item, i) => item.classList.toggle('highlighted', i === highlighted));
      items[highlighted].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter') {
      if (highlighted >= 0 && highlighted < items.length) {
        e.preventDefault();
        items[highlighted].dispatchEvent(new MouseEvent('mousedown'));
      }
    } else if (e.key === 'Escape') {
      close();
    }
  });

  document.addEventListener('click', e => {
    if (!e.target.closest('#search-wrap')) close();
  });
})();

// ---- The tag menu - the topbar button opens and closes partials/articles-menu ----
// The stylesheet has already drawn the default (open on a wide screen, closed
// at 768px and under), so this keeps aria-expanded true to what is on screen
// and, from the first press, states it as a body class. Not remembered across
// pages, like the map's list.
(function () {
  const menu = dom.id('articles-menu');
  const toggle = dom.id('sidebar-toggle');

  if (!menu || !toggle) return;

  const PHONE = window.matchMedia('(max-width: 768px)');

  // Read off the page rather than tracked, so it cannot disagree with the CSS.
  const isOpen = () => getComputedStyle(menu).display !== 'none';

  function set(open) {
    document.body.classList.toggle('articles-menu-open', open);
    document.body.classList.toggle('articles-menu-closed', !open);
    toggle.setAttribute('aria-expanded', String(open));

    // The page's column just changed width; the hero video sizes on resize.
    window.dispatchEvent(new Event('resize'));
  }

  toggle.setAttribute('aria-expanded', String(isOpen()));

  toggle.addEventListener('click', () => {
    // A phone's drawer hangs from the topbar, which wraps to two rows there.
    const topbar = dom.id('topbar');

    if (topbar) menu.style.setProperty('--articles-menu-top', Math.max(0, topbar.getBoundingClientRect().bottom) + 'px');

    set(!isOpen());
  });

  // The tag filter below has picked a tag: a phone's drawer gets out of the
  // way of the list it just filtered.
  menu.addEventListener('hc:tag-picked', () => {
    if (PHONE.matches && isOpen()) set(false);
  });

  // The drawer covers the article, so Escape or a tap beside it closes it.
  // A wide screen's column is left alone - it covers nothing.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !PHONE.matches || !isOpen()) return;

    set(false);
    toggle.focus();
  });

  document.addEventListener('click', (e) => {
    if (!PHONE.matches || !isOpen() || menu.contains(e.target) || toggle.contains(e.target)) return;

    set(false);
  });
})();

// ---- The tag filter - a tag in the menu filters the index in place ----
// Like the map's category filters: no page load, the URL becomes the tag's
// page (/articles/tags/<slug>/, which the server renders as this same view),
// Back and Forward walk the filters, and the active tag is marked in the menu.
// Picking it again, or "All categories", goes back to /articles/. The category
// cards above the list (partials/article-categories) filter the same way, and
// bring the articles they reveal into view. Every card is
// already on the page with its tags in data-tags, so filtering is toggling
// `hidden` - the server's markup is never redrawn. The index shows the
// featured row and the cards marked data-on-index (an article in no category;
// every one when there are no categories); a tag shows its own articles and
// hides the featured row, whose articles are in its list. The words each state wears
// come from the page config (window.__hcArticleViews, built by
// PageController::articleViews()), so a picked tag reads exactly as its URL
// loaded would. Modified clicks, and every page that is not the index (an
// article's menu), navigate as ordinary links.
(function () {
  const list = document.querySelector('[data-articles-list]');
  const menu = dom.id('articles-menu');
  const views = window.__hcArticleViews;

  if (!list || !menu || !views || !window.history || !history.pushState) return;

  const INDEX = '/articles/';
  const cards = dom.all('.article-card[data-tags]', list);
  const banner = list.querySelector('[data-articles-filter]');
  const bannerLabel = list.querySelector('[data-articles-filter-label]');
  const none = list.querySelector('[data-articles-none]');
  const heading = document.querySelector('#articles-hero-content h1');
  const intro = document.querySelector('#articles-hero-content .articles-intro');
  const categoryCards = dom.all('.article-category-card', list);
  const featured = dom.id('articles-featured');
  const categorySection = dom.id('article-categories');
  const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  // A path's tag, null for the index, undefined for anything else.
  function tagOf(path) {
    if (path === INDEX) return null;

    const m = path.match(/^\/articles\/tags\/([a-z0-9-]+)\/$/);

    return m && views.tags[m[1]] ? m[1] : undefined;
  }

  let current = tagOf(location.pathname) || null;

  function setHead(selector, attr, value) {
    const el = document.querySelector(selector);

    if (el) el.setAttribute(attr, value);
  }

  function apply(slug) {
    const view = slug ? views.tags[slug] : views.index;
    let shown = 0;

    current = slug;

    // Cards uncovered here lazy-load as they scroll in, as on first paint.
    cards.forEach((card) => {
      const on = slug
        ? card.dataset.tags.split(' ').indexOf(slug) !== -1
        : card.hasAttribute('data-on-index');

      card.hidden = !on;
      if (on) shown++;
    });

    // A category shows its articles alone: no featured row, no category cards.
    if (featured) featured.hidden = !!slug;
    if (categorySection) categorySection.hidden = !!slug;
    if (banner) banner.hidden = !slug;
    if (bannerLabel) dom.text(bannerLabel, slug ? view.heading : '');
    // The index with categories has them for content, whatever the list shows.
    if (none) none.hidden = shown > 0 || (!slug && (categoryCards.length > 0 || !!featured));
    if (heading) dom.text(heading, view.heading);
    if (intro) dom.text(intro, view.intro);

    document.title = view.title;
    setHead('meta[name="description"]', 'content', view.description);
    setHead('meta[property="og:title"]', 'content', view.title);
    setHead('meta[name="twitter:title"]', 'content', view.title);
    setHead('meta[property="og:description"]', 'content', view.ogDescription);
    setHead('meta[name="twitter:description"]', 'content', view.ogDescription);
    setHead('meta[property="og:url"]', 'content', view.url);
    setHead('link[rel="canonical"]', 'href', view.url);

    // The chip for what is showing - "All articles" when nothing is picked -
    // and the category card for it, if any.
    dom.all('.articles-chip', menu).concat(categoryCards).forEach((link) => {
      if (tagOf(link.getAttribute('href')) === slug) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const link = e.target.closest && e.target.closest('#articles-menu .articles-chip, .article-category-card, [data-articles-filter] a');

    if (!link) return;

    const picked = tagOf(link.getAttribute('href'));

    if (picked === undefined) return;

    e.preventDefault();

    // The active tag again clears the filter; "All articles" while
    // unfiltered changes nothing.
    const next = picked === current ? null : picked;

    if (next === current) return;

    apply(next);
    history.pushState({ articlesTag: next }, '', next ? '/articles/tags/' + next + '/' : INDEX);

    if (next && banner) {
      // Picked: the cards above are gone, so bring the breadcrumb row and the
      // articles under it into view.
      banner.scrollIntoView({ behavior: reducedMotion && reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
    } else if (list.getBoundingClientRect().top < 0) {
      // Back to the index: its featured row and categories are at the top.
      window.scrollTo(0, 0);
    }

    menu.dispatchEvent(new CustomEvent('hc:tag-picked'));
  });

  window.addEventListener('popstate', () => {
    const slug = tagOf(location.pathname);

    if (slug !== undefined) apply(slug);
  });
})();

// ---- Back to its category - an article's breadcrumb row ----
// The server points the back button and the trail's category at the article's
// first category. A reader who came from another of its own categories (that
// tag's page, or the index filtered to it) goes back there instead: same row,
// that category's name, read off the article's own chip for it.
(function () {
  const back = document.querySelector('[data-article-back]');

  if (!back || !document.referrer) return;

  let from;

  try {
    from = new URL(document.referrer);
  } catch (err) {
    return;
  }

  const m = from.origin === location.origin && from.pathname.match(/^\/articles\/tags\/([a-z0-9-]+)\/$/);
  const chip = m && document.querySelector('.article-tags .article-tag-chip[href="' + m[0] + '"]');

  if (!chip) return;

  const name = chip.textContent.trim();
  const backName = back.querySelector('.articles-crumbs-back-name');
  const crumb = document.querySelector('[data-article-crumb]');

  back.setAttribute('href', m[0]);
  if (backName) dom.text(backName, name);

  if (crumb) {
    crumb.setAttribute('href', m[0]);
    dom.text(crumb, name);
  }

  // The chips leave out the breadcrumb's category - now this one.
  const chips = Array.prototype.slice.call(document.querySelectorAll('.article-tags .article-tag-chip'));

  chips.forEach(c => { c.hidden = c === chip; });
  chip.parentNode.hidden = chips.length < 2;
})();

// ---- Back to top - articles routes, where the document scrolls ----
// The href="#" anchor works without JS; this shows it only once the reader is
// a viewport down, and scrolls smoothly unless reduced motion is preferred.
(function () {
  const btn = dom.id('back-to-top');

  if (!btn) return;

  const THRESHOLD = () => window.innerHeight || 600;

  /* WHICHEVER ELEMENT HOLDS THE SCROLL. The document scrolls here (see
     "ARTICLES SCROLL AS AN ORDINARY DOCUMENT" in main.css), but body is read
     and listened to as well in case that layout changes back. */
  function offset() {
    return Math.max(
      document.body.scrollTop || 0,
      window.scrollY || 0,
      document.documentElement.scrollTop || 0
    );
  }

  let ticking = false;

  function update() {
    ticking = false;
    btn.classList.toggle('visible', offset() > THRESHOLD());
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  document.body.addEventListener('scroll', onScroll, { passive: true });

  update();

  btn.addEventListener('click', (e) => {
    e.preventDefault();

    const reduced = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduced ? 'auto' : 'smooth';

    document.body.scrollTo({ top: 0, behavior });
    window.scrollTo({ top: 0, behavior });

    // Don't leave focus on a control that is about to fade out.
    btn.blur();
  });
})();

/* THE ANNOUNCEMENTS BAR, ON THE GUIDES.
   app.js's three behaviours for partials.announcements, since app.js is not
   loaded here: the cross hides it for the visit (same sessionStorage key, so
   it carries across both halves), a picture opens in the lightbox, and
   clicks emit "announcement-clicked". No "show again" pill on this side.
   Clicks are counted by the /announcements/<id>/open request, not here. */
(function () {
  if (!document.body.classList.contains('articles-mode')) return;

  const bar = document.getElementById('announcements');
  if (!bar) return;

  const KEY = 'hc:strip-dismissed:announcements';
  try { if (sessionStorage.getItem(KEY) === '1') bar.hidden = true; } catch (e) { /* no storage */ }

  const cross = bar.querySelector('[data-dismiss-strip="announcements"]');
  if (cross) {
    cross.addEventListener('click', () => {
      bar.hidden = true;
      try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* this page only */ }
    });
  }

  bar.addEventListener('click', (e) => {
    const card = e.target.closest('.announcement-card[data-announcement-id]');
    if (!card || !window.hcEvents) return;

    window.hcEvents.emit('announcement-clicked', {
      id: card.dataset.announcementId,
      title: card.dataset.announcementTitle || '',
      kind: card.tagName === 'A' ? 'link' : 'picture',
      url: card.getAttribute('href') || card.getAttribute('data-announcement-image') || null,
    });
  });

  const lightbox = document.getElementById('announcement-lightbox-backdrop');
  const img = document.getElementById('announcement-lightbox-img');
  if (!lightbox || !img) return;

  const close = () => {
    lightbox.classList.remove('visible');
    img.removeAttribute('src');
  };

  bar.addEventListener('click', (e) => {
    const card = e.target.closest('[data-announcement-image]');
    if (!card) return;

    e.preventDefault();
    // /announcements/<id>/open counts the click and redirects to the image.
    img.src = card.getAttribute('data-announcement-image');
    lightbox.classList.add('visible');
  });

  lightbox.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
})();
